import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

import {
  Row, Col, VertTag, VertButton, VertSelect, VertTypography, VertIcon,
} from '@vertem-core/vertice-ds';

const OrderOption = [
  {
    label: 'Mais Relevantes',
    value: 'SCORE',
  },
  {
    label: 'Mais Novos',
    value: 'NEWRELEASES',
  },
  {
    label: 'Maior Preço',
    value: 'PRICEHIGHERTOLOWER',
  },
  {
    label: 'Menor Preço',
    value: 'PRICELOWERTOHIGHER',
  },
];

const SelectOrderBy = ({
  toggleSearchSidebar, searchSidebarVisible, onChange, valueSort,
}) => {
  const [visibleFilter, setVisibleFilter] = useState(false);

  const openFilterHandler = () => {
    setVisibleFilter(!visibleFilter);
    toggleSearchSidebar(!visibleFilter); // Inverte o valor para mostrar/ocultar
  };
  return (
    <>
      <MediaQuery minWidth={769}>
        <Col className="vert-category vert-category-title-label col-2">
          <VertTypography.Paragraph className="margin-bottom-none txt-paragraph">Ordenar por:</VertTypography.Paragraph>
          <VertSelect
            popupClassName="vert-select-popup select-dropdown-marketplace"
            items={OrderOption}
            placeholder="Selecione"
            value={valueSort || 'SCORE'}
            className="margin-top-extra-small"
            onChange={(e) => {
              if (onChange) onChange(e);
            }}
          />
        </Col>
      </MediaQuery>
      <MediaQuery maxWidth={768}>
        <Col span={24}>
          <Row justify="center" align="middle" className="vert-category vert-category-mobile vert-category-title margin-bottom-regular" gutter={8}>
            <Col className="vert-box-filter vert-box-filter-title-button col">
              <VertButton
                icon={<VertIcon isVertice iconName="Filter" className="margin-right-extra-small" />}
                className="color-detached"
                spacing="extra-small"
                onClick={() => openFilterHandler()}
                aria-expanded={searchSidebarVisible}
              >
                Filtro
                {' '}
                <VertTag shape="round" status="error" className="borderless margin-left-extra-small margin-right-none">1</VertTag>
              </VertButton>
            </Col>
            <Col className="vert-category vert-category-title-label col-auto">
              <VertSelect
                className="borderless"
                popupClassName="vert-select-popup select-dropdown-marketplace"
                items={OrderOption}
                placeholder="Selecione"
                value={valueSort || 'SCORE'}
                onChange={(e) => {
                  if (onChange) onChange(e);
                }}
              />
            </Col>
          </Row>
        </Col>
      </MediaQuery>
    </>
  );
};

SelectOrderBy.propTypes = {
  toggleSearchSidebar: PropTypes.func.isRequired,
  searchSidebarVisible: PropTypes.bool,
  onChange: PropTypes.func,
  valueSort: PropTypes.string,
};

export default SelectOrderBy;
